var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandrecordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 480.681 480.681",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M0 460.652h480.681v20.028H0zM10.014 390.553h30.043v20.028H10.014zM70.099 390.553h30.043v20.028H70.099zM130.184 390.553h30.043v20.028h-30.043zM190.269 390.553h30.043v20.028h-30.043zM250.355 390.553h30.043v20.028h-30.043zM310.44 390.553h30.043v20.028H310.44zM370.525 390.553h30.043v20.028h-30.043zM430.61 390.553h30.043v20.028H430.61zM330.468 130.184h60.085v20.028h-60.085zM90.128 130.184h60.085v20.028H90.128zM57.181 340.482H0v-20.028h42.961l42.961-120.17H70.099v-20.029h44.263zM372.928 340.482H107.753l34.348-160.227h38.154v20.029h-21.931l-25.736 120.17h215.505l-25.737-120.17h-21.931v-20.029h38.154zM480.681 340.482H423.5l-57.181-160.227h44.262v20.029h-15.822l42.961 120.17h42.961z",
    opacity: 1,
    "data-original": "#4c4c4c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m240.34 236.235-7.811-9.614c-2.904-3.705-72.302-90.328-72.302-148.01C160.227 35.25 196.178 0 240.34 0s80.113 35.25 80.113 78.611c0 57.782-69.398 144.404-72.302 148.01zm0-216.207c-33.147 0-60.085 26.237-60.085 58.583 0 40.157 42.26 101.243 60.085 125.277 17.825-24.034 60.085-85.121 60.085-125.277 0-32.345-26.938-58.583-60.085-58.583z",
    opacity: 1,
    "data-original": "#4c4c4c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M240.34 110.156c-16.523 0-30.043-13.519-30.043-30.043S223.816 50.07 240.34 50.07s30.043 13.519 30.043 30.043-13.519 30.043-30.043 30.043zm0-40.057c-5.508 0-10.014 4.506-10.014 10.014s4.506 10.014 10.014 10.014 10.014-4.506 10.014-10.014c.001-5.507-4.506-10.014-10.014-10.014z",
    opacity: 1,
    "data-original": "#4c4c4c",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandrecordIcon);
export default __webpack_public_path__ + "static/media/landrecord-icon.03342fe821d7decd6fa3b1a6ff5ae8ac.svg";
export { ForwardRef as ReactComponent };